import React, { useState, useEffect } from "react";
import ReportClasses from "./Report.module.css";
import Loader from "Components/loader/loader";
import { IoInformationCircleSharp } from "react-icons/io5";
import { useForm } from "react-hook-form";
import moment from "moment";
import { warningSwal } from "Util/Toast";
import { Services } from "Services";
import ReactPaginate from "react-paginate";
import Moment from "react-moment";
import DateModa from "./UpdateDates/dates";
import { useSearchParams } from "react-router-dom";
import Terms from "./Modal/Modal";
function Report() {
    const [SearchParams] = useSearchParams();
    const [loading, setLoading] = useState(false);
    const [showPaginate, setShowPagiate] = useState(true);
    const [status, setStatus] = useState(0);
    const [pageCount, setpageCount] = useState(1);
    const [DateModal, setDateModal] = useState(false);
    const [TutorData, setTutorData] = useState();
    const [modalTerms, setTermsModal] = useState(false);
    let RecordCount = 20;

    const [data, setData] = useState([]);
    const [Active, setActive] = useState("TUTOR");

    const [Parent, setParent] = useState({
        TotalDurationMinutes: 0,
        NoOfClassesCancelled: 0,
        ImpactedMinutes: 0,
        ImpactedHours: 0,
    });
    const [Teachers, setTeachers] = useState({
        TotalDurationMinutes: 0,
        NoOfClassesCancelled: 0,
        ImpactedMinutes: 0,
        ImpactedHours: 0,
    });
    const [Others, setOthers] = useState({
        TotalDurationMinutes: 0,
        NoOfClassesCancelled: 0,
        ImpactedMinutes: 0,
        ImpactedHours: 0,
    });

    const [forcepage, setforcepage] = useState(0);

    const [modal, setModal] = useState(false);
    const token = {
        Authorization: `token ${localStorage.getItem("token")}`,
    };
    const {
        register,
        handleSubmit,
        watch,
        setValue,
        reset,
        formState: { },
    } = useForm();
    const WatchData = watch();

    useEffect(() => {
        ApiCall(null);
    }, []);

    const ApiCall = async (data) => {
        setLoading(true);
        try {
            let body = JSON.stringify({
                ...data,
                TutorID: SearchParams.get("TutorId"),
            });
            const [summaryData] = await Promise.all([
                Services.tutor_cancel_reports("POST", body, token),
            ]);

            if (summaryData.Status === 1) {
                getBatchRequests(Active, 0);
                setforcepage(0);
                let Parent = summaryData?.CancelReports.find(
                    (item) => item?.CancelType == "Parent"
                );
                setTutorData(summaryData?.TutorData[0]);

                setStatus(summaryData?.TutorData[0]?.LeaveStatus);

                if (Parent) {
                    setParent(Parent);
                } else {
                    setParent({
                        TotalDurationMinutes: 0,
                        NoOfClassesCancelled: 0,
                        ImpactedMinutes: 0,
                        ImpactedHours: 0,
                    });
                }
                let Other = summaryData?.CancelReports.find(
                    (item) => item?.CancelType == "Other"
                );
                if (Other) {
                    setOthers(Other);
                } else {
                    setOthers({
                        TotalDurationMinutes: 0,
                        NoOfClassesCancelled: 0,
                        ImpactedMinutes: 0,
                        ImpactedHours: 0,
                    });
                }
                let Tutor = summaryData?.CancelReports.find(
                    (item) => item?.CancelType == "Tutor"
                );
                if (Tutor) {
                    setTeachers(Tutor);
                } else {
                    setTeachers({
                        TotalDurationMinutes: 0,
                        NoOfClassesCancelled: 0,
                        ImpactedMinutes: 0,
                        ImpactedHours: 0,
                    });
                }
                /*  if (summaryData.Earnings != null) {
                    setEarning({
                        Earnings:
                            summaryData.Earnings != null
                                ? summaryData.Earnings
                                : 0,
                        NeedToPay:
                            summaryData.NeedToPay != null
                                ? summaryData.NeedToPay
                                : 0,
                    });
                } */
            }
        } catch {
            setLoading(false);
            alert("something went wrong try again");
        }
    };

    useEffect(() => {
        getBatchRequests(Active, 0);
    }, [Active]);

    // ---GET BATCH REQUESTS

    async function getBatchRequests(Type, skip) {
        try {
            const response = await Services.cancelledclasses_by_type(
                "POST",
                JSON.stringify({
                    CancelledByType: Type,
                    toSkip: skip,
                    EndDate: WatchData.ToDate,
                    StartDate: WatchData?.FromDate,
                    TutorID: SearchParams.get("TutorId"),
                }),
                token
            );

            setTimeout(() => {
                setLoading(false);
            }, 200);
            if (response?.Status == 1) {
                setData(response.CancelReports);
                if (
                    response.CancelReports.length == 0 ||
                    response.ClassesCount <= RecordCount
                ) {
                    setShowPagiate(false);
                } else {
                    if (!showPaginate) {
                        setShowPagiate(true);
                    }
                    setpageCount(
                        Math.ceil(
                            Number(response?.ClassesCount) / Number(RecordCount)
                        )
                    );
                }
            }
        } catch (err) {
            console.log(err);
            setLoading(false);
            Error("something went wrong please try again");
        }
    }

    const onSubmit = async (data) => {
        if (moment(data.FromDate).isAfter(data.ToDate)) {
            warningSwal("Warning", "Invalid Date range");
            return;
        }
        ApiCall(data);
    };
    const NavHandler = (type) => {
        setActive(type);
        setforcepage(0);
    };
    const handlePageChange = (selectedObject) => {
        console.log(selectedObject);

        window.scrollTo({ top: 450, behavior: "smooth" });
        setforcepage(selectedObject.selected);
        getBatchRequests(Active, selectedObject.selected * RecordCount);
        setLoading(true);
    };
    const statusHandler = (e) => {
        if (e.target.value == 1) {
            setDateModal(true);
        }
    };
    return (
        <div className={ReportClasses["Container"]}>
            {modalTerms && (
                <Terms modal={modalTerms} setModal={setTermsModal} />
            )}
            {loading && <Loader />}
            <DateModa
                completemodal={DateModal}
                setModal={setDateModal}
                TutorData={TutorData}
                TutorID={SearchParams.get("TutorId")}
                data={() => {
                    setforcepage(0);
                    setStatus(1);
                    ApiCall(null);
                    setDateModal(false);
                }}
            />
            <div
                className={ReportClasses["Container"]}
                style={{ minHeight: "100%" }}>
                <div className={ReportClasses["wrapper"]}>
                    <header>
                        <div>
                            <h3>
                                Cancellation Report{" "}
                                <button onClick={() => setTermsModal(true)}>
                                    <IoInformationCircleSharp />
                                </button>
                            </h3>
                        </div>
                        <form
                            className={ReportClasses["filter"]}
                            onSubmit={handleSubmit(onSubmit)}>
                            <div>
                                <input
                                    type="text"
                                    placeholder="From Date"
                                    {...register("FromDate", {
                                        required: true,
                                    })}
                                    onClick={(event) => {
                                        const inputElement = event.target;
                                        inputElement.type = "date";
                                    }}
                                />
                                <input
                                    type="text"
                                    placeholder="To Date"
                                    {...register("ToDate", {
                                        required: true,
                                    })}
                                    onClick={(event) => {
                                        const inputElement = event.target;
                                        inputElement.type = "date";
                                    }}
                                />
                                <button>Submit</button>
                            </div>
                        </form>
                    </header>
                    <div className={ReportClasses["earnings"]}>
                        <div>
                            <p>No. of classes cancelled by the teacher </p>
                            <h3>{Teachers?.NoOfClassesCancelled}</h3>
                            <p>(impacted hours)</p>
                            <h3 style={{ fontSize: "1.2rem" }}>
                                {Teachers?.ImpactedHours != 0 &&
                                    `${Teachers.ImpactedHours} Hour`}{" "}
                                {Teachers?.ImpactedMinutes != 0 &&
                                    `${Teachers.ImpactedMinutes} Minutes`}
                                {Teachers?.ImpactedMinutes == 0 &&
                                    Teachers?.ImpactedHours == 0 &&
                                    `0 Minutes`}
                            </h3>
                        </div>
                        <div>
                            <p>No. of classes cancelled by the parent</p>
                            <h3>{Parent?.NoOfClassesCancelled}</h3>
                            <p>(impacted hours)</p>
                            <h3 style={{ fontSize: "1.2rem" }}>
                                {Parent?.ImpactedHours != 0 &&
                                    `${Parent.ImpactedHours} Hour`}{" "}
                                {Parent?.ImpactedMinutes != 0 &&
                                    `${Parent.ImpactedMinutes} Minutes`}
                                {Parent?.ImpactedMinutes == 0 &&
                                    Parent?.ImpactedHours == 0 &&
                                    `0 Minutes`}
                            </h3>
                        </div>
                        <div>
                            <p>No. of classes cancelled by the RM</p>
                            <h3>{Others?.NoOfClassesCancelled}</h3>
                            <p>(impacted hours)</p>
                            <h3 style={{ color: "blue", fontSize: "1.2rem" }}>
                                {Others?.ImpactedHours != 0 &&
                                    `${Others.ImpactedHours} Hour`}{" "}
                                {Others?.ImpactedMinutes != 0 &&
                                    `${Others.ImpactedMinutes} Minutes`}
                                {Others?.ImpactedMinutes == 0 &&
                                    Others?.ImpactedHours == 0 &&
                                    `0 Minutes`}
                            </h3>
                        </div>
                    </div>
                </div>
            </div>
            <div className={ReportClasses["Container"]}>
                <div className={ReportClasses["longLeave"]}>
                    <div>
                        <label>Long Leave Taken</label>
                        <select
                            style={{ width: "10rem" }}
                            disabled={TutorData?.LeaveStatus != 0}
                            value={status}
                            onChange={(e) => statusHandler(e)}>
                            <option value={1}>Yes</option>
                            <option value={0}>No</option>
                            <option value={2}>Not available</option>
                        </select>
                    </div>
                    {status == 1 && (
                        <label>
                            Leave Requested from{" "}
                            {String(TutorData?.FromDate).split("T")[0]} to{" "}
                            {String(TutorData?.ToDate).split("T")[0]}{" "}
                        </label>
                    )}
                </div>
                <div className={ReportClasses["Tutor"]}>
                    <h3>Classes</h3>
                    <div className={ReportClasses["Navigator"]}>
                        <button
                            custom-btn-type="TUTOR"
                            className={
                                Active === "TUTOR"
                                    ? ReportClasses["active"]
                                    : ""
                            }
                            onClick={() => NavHandler("TUTOR")}>
                            TUTOR
                        </button>
                        <button
                            custom-btn-type="PARENT"
                            className={
                                Active === "PARENT"
                                    ? ReportClasses["active"]
                                    : ""
                            }
                            onClick={() => NavHandler("PARENT")}>
                            Parent
                        </button>
                        <button
                            custom-btn-type="OTHERS"
                            className={
                                Active === "OTHERS"
                                    ? ReportClasses["active"]
                                    : ""
                            }
                            onClick={() => NavHandler("OTHERS ")}>
                            RM
                        </button>
                    </div>
                    <div className={ReportClasses["Table"]}>
                        <table>
                            <thead>
                                <tr>
                                    <th>Class</th>

                                    <th>Start Date Time</th>
                                    <th>Duration</th>
                                    <th>Batch </th>
                                    <th>Cancel Reason</th>
                                    <th>Comments</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data.length > 0 ? (
                                    data.map((item, index) => {
                                        const timeStr = item?.DemoStartTime;

                                        // Combine date and time
                                        const dateTime = moment(
                                            item?.DemoStartDate
                                        ).set({
                                            hour: moment(
                                                timeStr,
                                                "HH:mm:ss"
                                            ).hours(),
                                            minute: moment(
                                                timeStr,
                                                "HH:mm:ss"
                                            ).minutes(),
                                            second: moment(
                                                timeStr,
                                                "HH:mm:ss"
                                            ).seconds(),
                                        });
                                        return (
                                            <tr>
                                                <td>{item.ClassLessonName}</td>

                                                <td>
                                                    <Moment format="DD-MM-YYYY">
                                                        {
                                                            new Date(
                                                                item.Scheduled_StartDate
                                                            )
                                                        }
                                                    </Moment>{" "}
                                                    <br />
                                                    {String(
                                                        item.Scheduled_StartTime
                                                    )}
                                                </td>

                                                <td>
                                                    {" "}
                                                    {item.ClassDuration} Min
                                                </td>
                                                <td style={{ maxWidth: '10rem' }}>{item?.BatchName}</td>

                                                <td
                                                    style={{
                                                        wordBreak: "break-word",
                                                        maxWidth: "3rem",
                                                    }}>
                                                    {item.Cancellation_Policy_Type === 'Is_After' ? ' Parent asked to cancel within 60 minutes' : item.Cancellation_Policy_Type === 'Is_Before' ? ' Parent asked to cancel before 60 minutes' : item.CancelReason}

                                                </td>
                                                <td
                                                    style={{
                                                        wordBreak: "break-word",
                                                        maxWidth: "8rem",
                                                    }}>
                                                    {item.Comments}
                                                </td>
                                            </tr>
                                        );
                                    })
                                ) : (
                                    <tr>
                                        <td colSpan={6}> no records Found</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                    {showPaginate && (
                        <div
                            style={{
                                justifySelf: "right",
                            }}>
                            <ReactPaginate
                                pageCount={pageCount}
                                // pageRange={2}
                                forcePage={forcepage}
                                marginPagesDisplayed={2}
                                onPageChange={handlePageChange}
                                breakClassName={"page-item"}
                                breakLinkClassName={"page-link"}
                                containerClassName={"pagination"}
                                pageClassName={"page-item"}
                                pageLinkClassName={"page-link"}
                                previousClassName={"page-item"}
                                previousLinkClassName={"page-link"}
                                nextClassName={"page-item"}
                                nextLinkClassName={"page-link"}
                                activeClassName={"active"}
                            />
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

export default Report;
